// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** GET MEMBER DETAILS START *********************** */
export const memberDetailsGetService = (verifyData: any) => {
	const data = {
		MemberProfileDetailsToken: verifyData,
	};

	const url = `${API_URL}fetchMemberDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET MEMBER DETAILS END *********************** */

/** ***************** FETCH PARTICULAR MEMBER DETAILS START *********************** */
export const fetchMemberData = (fetchData: any, serviceName: string) => {
	const data = {
		FetchMemberDetailsToken: fetchData,
	};
	const url = `${API_URL + serviceName}`;
	return makeApiCall(url, data);
};
/** ***************** FETCH PARTICULAR MEMBER DETAILS END *********************** */

/** ***************** GET MEMBER MANDATORY FIELDS START *********************** */
export const memberMandatoryGetService = (fetchData: any) => {
	const data = {
		MemberMandatoryDetailsToken: fetchData,
	};
	const url = `${API_URL}getMandatoryDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET MEMBER MANDATORY FIELDS END *********************** */

/** ***************** FETCH ADD MEMBER LIST START *********************** */
export const addMemberListFetchService = (Data: any) => {
	const data = {
		AddMemberToken: Data,
	};
	const url = `${API_URL}getMemeberList`;
	return makeApiCall(url, data);
};
/** ***************** FETCH ADD MEMBER LIST END *********************** */

/** ***************** DELETE MEMBER START *********************** */
export const deleteMemberService = (Data: any) => {
	const data = {
		DeleteMemberToken: Data,
	};
	const url = `${API_URL}deleteMember`;
	return makeApiCall(url, data);
};
/** ***************** DELETE MEMBER END *********************** */

/** ***************** CHECK ALL MANDATORY FIELDS START *********************** */
export const checkMandateMember = (check: any) => {
	const data = {
		MemberMandatoryToken: check,
	};
	const url = `${API_URL}checkMandatoryData`;
	return makeApiCall(url, data);
};
/** ***************** CHECK ALL MANDATORY FIELDS END *********************** */
